export const slick_Setting = {
    initialSlide: 1,
    adaptiveHeight: true,
    dots: true,
    arrows:true,
    rtl : true,
    slidesToShow: 3,
    slidesToScroll:3,
    height:600,
    centerMode : false,
    infinite:false,
    responsive:[
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll:3,
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll:2,
            }
        },
        {
            breakpoint: 600,
            settings: {
                initialSlide: 0,
                slidesToShow: 1,
                infinite:true,
                slidesToScroll:1,
            }
        },
        {
            breakpoint: 480,
            settings: {
                initialSlide: 0,
                slidesToShow: 1,
                infinite:true,
                slidesToScroll:1,
            }
        }
    ]
};

export const slick_Setting2 = {
    initialSlide: 3,
    infinite: false,
    adaptiveHeight: false,
    dots: false,
    centerMode : false,
    arrows:false,
    rtl : true,
    slidesToShow: 3,
    slidesToScroll:3,
    responsive:[
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll:3,
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll:3,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll:1,
                centerMode : true,
                centerPadding:"0px",
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 480,
            settings: {
                centerMode : true,
                centerPadding: "0px",
                slidesToShow: 1,
                slidesToScroll:1,
                infinite: true,
                dots: true
            }
        }
    ]
};

const domain = (window.origin.includes("localhost") ? "https://fa-capital.co" : window.origin);
export const Setting = {
    system : "Family Capital",
    loginUrl : "../login",
    domain : domain + "/",
    assets : domain + "/assets/",
    public : domain + "/public_img/",
    timeout : 1500,
    systemName : "Family Capital",
    developmentBy : "",
    developmentUrl :"",
    apiUrl : domain + "/api/",
    email: "admin@"+window.origin.replaceAll("https://","").replaceAll("http://",""),
    platform : "https://wt.24-equity.com/login"
}
export let webData:any = {
    SliderData: [],
    Testimonial: [],
    Profit: [],
    WebSetting : [] as any,
    Category : [],
    User : {
        token: localStorage.getItem("token") || null,
        FirstName: localStorage.getItem("FirstName") || "",
        LastName: localStorage.getItem("LastName") || "",
        Email: localStorage.getItem("Email") || "",
        Phone: localStorage.getItem("Phone") || "",
        tpId: localStorage.getItem("tpId") || "",
        PaymentGateway: localStorage.getItem("PaymentGateway") || "",
        Balance: localStorage.getItem("Balance") || "",
        userId: localStorage.getItem("userId") || "",
        accountType: localStorage.getItem("accountType") || "",
        status: localStorage.getItem("status") || ""
    } as any,
    Fatoora :[] as any
}

export const Investment = ["اقل من  500","500-1,000","1,000-5,000","5,000-10,000","10,000-50,000","50,000-100,000","100,000+"]
export const CallTime = ["09:00-11:00","11:00-13:00","13:00-15:00","15:00-17:00","17:00-19:00","كل ساعات"]
//export const Age = ["تحت 18","18-24","25-30","30-40","40-50","50-60","اكبر سنا"]
export const Age = ["تحت 25","25-35","35-40","40-50","اكبر من 50"]
export const CategoryType = [
    {
        title :  "لا يوجد",
        path : "./",
        id: false
    },{
        title :  "المدونة",
        path : "./blog",
        id: false
    },{
        title :  "صفحة تعريفية",
        path : "./page/",
        id: true
    },{
        title :  "رابط",
        path : "./",
        id: false
    },{
        title :  "الاصول المالية",
        path : "./assets",
        id: false
    },{
        title :  "أدوات التداول",
        path : "./tradingTools",
        id: false
    },{
        title :  "منصات التداول",
        path : "./platforms",
        id: false
    },{
        title :  "أنواع الحسابات",
        path : "./accountType",
        id: false
    },{
        title :  "المفكرة الاقتصادية",
        path : "./calender",
        id: false
    },{
        title :  "أخبار السوق",
        path : "./news",
        id: false
    },{
        title :  "التحليلات الفنية",
        path : "./technicalAnalytics",
        id: false
    },{
        title :  "تحليل السوق اليومي",
        path : "./dailyAnalysis",
        id: false
    },{
        title :  "التوصية اليومية",
        path : "./dailyRecommendation",
        id: false
    },{
        title :  "اتصل بنا",
        path : "./contactus",
        id: false
    }
]
